import React, { ReactElement } from 'react'
import { Flex, Text } from 'theme-ui'
import { Svg } from 'ui'
import Hero from 'images/homePage/hero.svg'
import { staticPageHeaderHeight, staticPageMarginTop } from 'components/StaticPage/StaticPage'
import GetStartedButton from './GetStartedButton'

const TopSection = (): ReactElement => {
  return (
    <Flex
      sx={{
        width: '100%',
        height: ['auto', '93.2rem', '70rem'],
        mt: staticPageMarginTop,
        justifyContent: 'center',
        backgroundImage: `linear-gradient(0deg, hsl(245deg 50% 24%) 0%, hsl(241deg 48% 22%) 22%, hsl(238deg 47% 20%) 33%,
         hsl(236deg 47% 18%) 42%, hsl(234deg 45% 16%) 50%, hsl(233deg 42% 14%) 58%, hsl(232deg 37% 12%) 67%,
          hsl(232deg 31% 11%) 78%, hsl(234deg 22% 9%) 100%);`,
        backgroundPositionY: staticPageHeaderHeight,
      }}
    >
      <Flex
        sx={{
          width: '108rem',
          alignSelf: 'center',
          mt: ['10.8rem', '16.8rem', '19.8rem'],
          mb: ['3rem', '9rem', '11rem'],
          flexDirection: ['column', 'column', 'row'],
        }}
      >
        <Flex
          sx={{
            width: ['28.8rem', '46.8rem', '86.8rem'],
            flexDirection: 'column',
            alignItems: ['center', 'center', 'flex-start'],
            textAlign: ['center', 'center', 'left'],
            pr: [0, 0, '4.8rem'],
            alignSelf: ['center', 'center', 'left'],
            mb: '4.8rem',
          }}
        >
          <Text
            as="h2"
            data-testid="top-section-title"
            sx={{
              fontSize: ['3.6rem', '4.8rem'],
              lineHeight: '1.17',
              fontWeight: 'bold',
              color: 'white',
              mb: '2.4rem',
            }}
          >
            Mind your own business.
          </Text>
          <Text
            sx={{
              fontSize: ['1.8rem', '2.1rem'],
              color: 'aliceBlue60',
              width: ['fit-content', 'fit-content', '100%'],
              mb: '4.8rem',
            }}
          >
            Control D is a DNS service that improves your privacy and productivity. Block unwanted
            content, spoof your location and browse faster. No apps to install.
          </Text>
          <GetStartedButton dataTestId="get-started-button" />
        </Flex>
        <Flex sx={{ width: '100%', justifyContent: 'center', alignItems: 'center' }}>
          <Svg
            svg={Hero}
            sx={{
              height: ['17.6rem', '27.3rem'],
            }}
            descriptiveText="Homepage hero illustration showing privacy and productivity features"
          />
        </Flex>
      </Flex>
    </Flex>
  )
}

export default TopSection
